import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Caption1, formatCurrency } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useExpensesTotalInfo } from "~/repository/useExpensesTotalInfo";
import { getCurrencyCodeByProjectId, getFormatCurrencyArgs } from "~/store/selectors/selector.currencies";
import { getProjectById } from "~/store/selectors/selector.projects";
import { getLoggedUser } from "~/store/selectors/selector.users";
import { isFinancialManager, isMember } from "~/utils/userHelper";

export const LimitedAccess = ({ projectId, parentType, parentId, showLimitedAccess, className }) => {
  const { t } = useTranslation();

  const { data } = useExpensesTotalInfo(parentType, parentId);

  const loggedUser = useSelector((state) => getLoggedUser(state));
  const project = useSelector((state) => getProjectById(state, projectId));
  const currencyCode = useSelector((state) => getCurrencyCodeByProjectId(state, projectId));

  const formatterArgs = useSelector((state) => getFormatCurrencyArgs(state, currencyCode));

  const show =
    isMember(loggedUser) &&
    !isFinancialManager(loggedUser) &&
    project.leader_id !== loggedUser.id &&
    data?.others > 0 &&
    showLimitedAccess;

  return (
    <>
      {show ? (
        <div className={classNames("tw-border-solid tw-border-0 tw-border-t tw-border-border-primary", className)}>
          <div className="tw-px-1 tw-flex tw-justify-between tw-items-center tw-mt-4">
            <Caption1 weight="bold">{t("Limited Access")}</Caption1>
            <Caption1
              weight="medium"
              color="secondary"
              tabularNums
            >
              {t("Total")}:{" "}
              {formatCurrency(
                data.others,
                formatterArgs.thousand_separator,
                formatterArgs.decimal_separator,
                true,
                formatterArgs.decimal_spaces,
                "short",
                formatterArgs.code
              )}
            </Caption1>
          </div>
        </div>
      ) : null}
    </>
  );
};

LimitedAccess.propTypes = {
  projectId: PropTypes.number.isRequired,
  parentType: PropTypes.string.isRequired,
  parentId: PropTypes.number.isRequired,
  showLimitedAccess: PropTypes.bool,
  className: PropTypes.string,
};

LimitedAccess.defaultProps = {
  showLimitedAccess: false,
};
